import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() === "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getOverAllSummary = async (payload) => {
  try {
    const response = await api.post("api/Credits/overall-summary", payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getRegionSummary = async (payload) => {
  try {
    const response = await api.post("/api/Credits/region-summary", payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getItemSummary = async (payload) => {
  try {
    const response = await api.post(`/api/Credits/item-summary`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getStoreSummary = async (payload) => {
  try {
    const response = await api.post(`/api/Credits/store-summary`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const editStoreSummaryCreditReason = async (payload) => {
  try {
    const response = await api.put(`/api/Credits/credit-reason`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const editStoreSummaryDenialReason = async (payload) => {
  try {
    const response = await api.put(`/api/Credits/denial-reason`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getBillbackSummary = async (payload) => {
  try {
    const response = await api.post(`/api/Credits/billback/search`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const saveBillbackSummary = async (payload) => {
  try {
    const response = await api.put(`/api/Credits/billback`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getBillbackViewRecords = async (payload) => {
  try {
    const response = await api.post(`/api/Credits/billback/records`, payload);
    return response?.data?.result?.result;
  } catch (error) {
    errorHandler(error);
  }
};
